import { render } from "./HomeMessages.vue?vue&type=template&id=f4c159d2&scoped=true"
import script from "./HomeMessages.vue?vue&type=script&lang=js"
export * from "./HomeMessages.vue?vue&type=script&lang=js"

import "./HomeMessages.vue?vue&type=style&index=0&id=f4c159d2&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c159d2"]])

export default __exports__